const selectDeviceStatusChangeCodes = state => state.data.deviceStatusChangeCodes

const DeviceStatusChangeCodeDataStoreSelectors = {
  deviceStatusChangeCodes: selectDeviceStatusChangeCodes
}

export default DeviceStatusChangeCodeDataStoreSelectors
